import { useLocation } from "react-router-dom";
import { useEffect, useRef } from "react";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";
import { Helmet } from 'react-helmet-async';

const NotFound = () => {
  const location = useLocation();
  const pageRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  useEffect(() => {
    if (pageRef.current && document.body.classList.contains('dark')) {
      // Only add stars in dark mode
      const starsContainer = document.createElement('div');
      starsContainer.className = 'stars';
      
      // Create random stars
      for (let i = 0; i < 80; i++) {
        const star = document.createElement('div');
        star.className = 'star';
        star.style.left = `${Math.random() * 100}%`;
        star.style.top = `${Math.random() * 100}%`;
        star.style.animationDelay = `${Math.random() * 4}s`;
        starsContainer.appendChild(star);
      }
      
      // Create shooting stars (fewer, more subtle)
      for (let i = 0; i < 1; i++) {
        const shootingStar = document.createElement('div');
        shootingStar.className = 'shooting-star';
        shootingStar.style.top = `${Math.random() * 30}%`;
        shootingStar.style.left = `${Math.random() * 70 + 30}%`;
        shootingStar.style.animationDelay = `${Math.random() * 15}s`;
        starsContainer.appendChild(shootingStar);
      }
      
      pageRef.current.appendChild(starsContainer);
      
      return () => {
        if (pageRef.current && pageRef.current.contains(starsContainer)) {
          pageRef.current.removeChild(starsContainer);
        }
      };
    }
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center pt-24 pb-16 bg-gradient-to-b from-primary/10 to-background dark:from-primary/5">
      <Helmet>
        <title>404 Not Found | Omnicraft Services</title>
        <meta name="description" content="Sorry, the page you are looking for does not exist. Find your way back to our main sections." />
      </Helmet>
      <div className="text-center max-w-xl mx-auto p-8 bg-white/80 dark:bg-slate-900/80 rounded-2xl shadow-lg">
        <h1 className="text-5xl font-bold text-primary mb-4">404</h1>
        <h2 className="text-2xl font-semibold mb-2">Page Not Found</h2>
        <p className="mb-6 text-slate-600 dark:text-slate-300">Sorry, the page you are looking for does not exist or has been moved. Here are some helpful links to get you back on track:</p>
        <nav className="flex flex-wrap justify-center gap-4 mb-4">
          <a href="/" className="text-primary hover:underline font-medium">Home</a>
          <a href="/services" className="text-primary hover:underline font-medium">Services</a>
          <a href="/portfolio" className="text-primary hover:underline font-medium">Portfolio</a>
          <a href="/contact" className="text-primary hover:underline font-medium">Contact</a>
        </nav>
        <p className="text-sm text-slate-500">If you believe this is an error, please <a href="/contact" className="underline text-primary">let us know</a>.</p>
      </div>
    </div>
  );
};

export default NotFound;
